import { render, staticRenderFns } from "./ContentFormGiayBienNhan.vue?vue&type=template&id=66b32601&scoped=true"
import script from "./ContentFormGiayBienNhan.vue?vue&type=script&lang=js"
export * from "./ContentFormGiayBienNhan.vue?vue&type=script&lang=js"
import style0 from "./ContentFormGiayBienNhan.vue?vue&type=style&index=0&id=66b32601&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66b32601",
  null
  
)

export default component.exports